import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { defaultLang } from "./config-lang";
//
import translationEn from "./langs/en.json";
import translationFr from "./langs/fr.json";
import translationEs from "./langs/es.json";
import translationTh from "./langs/th.json";
import translationIt from "./langs/it.json";
import translationDe from "./langs/de.json";
import translationAr from "./langs/ar.json";
import translationBg from "./langs/bg.json";
import translationCa from "./langs/ca.json";
import translationCs from "./langs/cs.json";
import translationZh from "./langs/zh.json";
import translationHr from "./langs/hr.json";
import translationDa from "./langs/da.json";
import translationFi from "./langs/fi.json";
import translationEl from "./langs/el.json";
import translationHe from "./langs/he.json";
import translationHi from "./langs/hi.json";
import translationJa from "./langs/ja.json";
import translationKo from "./langs/ko.json";
import translationNo from "./langs/no.json";
import translationPl from "./langs/pl.json";
import translationPt from "./langs/pt.json";
import translationSv from "./langs/sv.json";
import translationTr from "./langs/tr.json";
import translationVi from "./langs/vi.json";

// ----------------------------------------------------------------------

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translations: translationEn },
            fr: { translations: translationFr },
            es: { translations: translationEs },
            th: { translations: translationTh },
            it: { translations: translationIt },
            de: { translations: translationDe },
            ar: { translations: translationAr },
            bg: { translations: translationBg },
            ca: { translations: translationCa },
            cs: { translations: translationCs },
            zh: { translations: translationZh },
            hr: { translations: translationHr },
            da: { translations: translationDa },
            fi: { translations: translationFi },
            el: { translations: translationEl },
            he: { translations: translationHe },
            hi: { translations: translationHi },
            ja: { translations: translationJa },
            ko: { translations: translationKo },
            no: { translations: translationNo },
            pl: { translations: translationPl },
            pt: { translations: translationPt },
            sv: { translations: translationSv },
            tr: { translations: translationTr },
            vi: { translations: translationVi },
        },
        fallbackLng: defaultLang.value,
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: [
                "querystring",
                "sessionStorage",
                "localStorage",
                "navigator",
                "htmlTag",
            ],
            lookupQuerystring: "lang",
            lookupLocalStorage: "i18nextLng",
            lookupSessionStorage: "language",
        },
    });

export default i18n;
